/**
 * Enum-like constants for the KC status field.
 *
 * Use the `KC_STATUS` object members (e.g. `KC_STATUS.MASTERED`) instead of
 * raw string literals (`'MASTERED'`) in code so that renames are mechanical
 * and unknown values fail at compile time. The literal-string union form
 * (`KcStatus`) remains the canonical type for API contracts and mocks.
 */
export const KC_STATUS = {
  MASTERED: 'MASTERED',
  NEEDS_PROOF: 'NEEDS_PROOF',
  ROLLBACK: 'ROLLBACK',
  ROLLBACK_RESOLVED: 'ROLLBACK_RESOLVED',
} as const;

export type KcStatus = typeof KC_STATUS[keyof typeof KC_STATUS];

/** Lifecycle status of a radar alert (annotation). */
export const RADAR_ALERT_STATUS = {
  PENDING: 'PENDING',
  REVIEWED: 'REVIEWED',
  DISMISSED: 'DISMISSED',
  RESOLVED: 'RESOLVED',
} as const;

export type RadarAlertStatus = typeof RADAR_ALERT_STATUS[keyof typeof RADAR_ALERT_STATUS];

/** API-side annotation item type discriminator. */
export const ANNOTATION_ITEM_TYPE = {
  FLAGGED_MESSAGE: 'FLAGGED_MESSAGE',
  LEARNING_ALERT: 'LEARNING_ALERT',
  GROUP_LEARNING_ALERT: 'GROUP_LEARNING_ALERT',
} as const;

export type AnnotationItemType = typeof ANNOTATION_ITEM_TYPE[keyof typeof ANNOTATION_ITEM_TYPE];
